import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { escapeHtml } from '@maximizer/shared/util';
import { OutlookAiMarkupUtils } from '../iq-boost/utils/ai-markup-utils';
import {
  ENTITY_KEY_PARAM,
  isValidBase64KeyToken,
} from '../iq-boost/utils/entity-key.utils';
import { getCRMActionFromVariation } from '../iq-boost/utils/crm-action-helper';

@Pipe({ name: 'outlookClickableRef' })
export class OutlookClickableRefPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  private readonly onFormatTemplate = this.translate.instant(
    'outlook.ai.references.onFormat',
  );

  transform(value?: string | null): string {
    if (!value) return '';

    try {
      return OutlookAiMarkupUtils.replaceMaximizerReferences(value, (params) =>
        this.buildLink(params),
      );
    } catch {
      return value;
    }
  }

  private buildLink(params: Record<string, string>): string {
    const type = params['type']?.toLowerCase() ?? '';
    const matchingAction = getCRMActionFromVariation(type);
    const translatedType = matchingAction?.result?.typeTranslationKey
      ? this.translate.instant(matchingAction.result.typeTranslationKey)
      : this.translate.instant('outlook.types.entity');
    const label = this.onFormatTemplate
      .replace('{0}', escapeHtml(translatedType))
      .replace('{1}', escapeHtml(params['date'] || ''));

    const entityKeyParam = params[ENTITY_KEY_PARAM] ?? '';
    const entityKey = isValidBase64KeyToken(entityKeyParam)
      ? entityKeyParam
      : '';

    // Temporarily non-clickable until readonly dialog component is implemented.
    return `<span class="text-neutral-90" data-key="${entityKey}">${label}</span>`;
  }
}
